import { SiteLayout } from "@/components/site/SiteLayout";

const CONTENT = {
  impressum: {
    title: "Impressum",
    body: [
      ["Angaben gemäß § 5 TMG", "KONTINENTZEIT Medien GmbH\nFriedrichstraße 100\n10117 Berlin\nDeutschland"],
      ["Vertreten durch", "Chefredaktion: Dr. Stefan Hoffmann\nGeschäftsführung: Klara Bergmann"],
      ["Kontakt", "Telefon: +49 30 000000\nE-Mail: redaktion@kontinentzeit.eu"],
      ["Registereintrag", "Eintragung im Handelsregister.\nRegistergericht: Amtsgericht Berlin-Charlottenburg\nRegisternummer: HRB 000000"],
      ["Verantwortlich für den Inhalt", "Dr. Stefan Hoffmann, Friedrichstraße 100, 10117 Berlin"],
    ],
  },
  kontakt: {
    title: "Kontakt",
    body: [
      ["Redaktion", "E-Mail: redaktion@kontinentzeit.eu\nTelefon: +49 30 000000"],
      ["Leserservice", "E-Mail: service@kontinentzeit.eu"],
      ["Anzeigen & Kooperationen", "E-Mail: anzeigen@kontinentzeit.eu"],
      ["Postanschrift", "KONTINENTZEIT Medien GmbH\nFriedrichstraße 100\n10117 Berlin"],
    ],
  },
  datenschutz: {
    title: "Datenschutz",
    body: [
      ["Datenschutz auf einen Blick", "Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003)."],
      ["Newsletter", "Wenn Sie den auf der Website angebotenen Newsletter beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse. Die Einwilligung können Sie jederzeit widerrufen."],
      ["Ihre Rechte", "Ihnen stehen die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu."],
    ],
  },
};

export function StaticPage({ page }) {
  const c = CONTENT[page];
  return (
    <SiteLayout>
      <div className="max-w-[760px] mx-auto px-4 py-12">
        <h1 className="font-headline font-black text-prussian text-4xl md:text-5xl tracking-tight border-b-2 border-prussian pb-4">{c.title}</h1>
        <div className="mt-8 space-y-8">
          {c.body.map(([h, t]) => (
            <section key={h}>
              <h2 className="font-headline font-bold text-xl text-prussian mb-2">{h}</h2>
              <p className="font-body text-charcoal/85 leading-relaxed whitespace-pre-line">{t}</p>
            </section>
          ))}
        </div>
      </div>
    </SiteLayout>
  );
}
